// extracted by mini-css-extract-plugin
export default {"preloaderWrapper":"Preloader_preloaderWrapper__BvfL4","preloader":"Preloader_preloader__e056+","rot":"Preloader_rot__PiMvD"};